import { useQuery } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';

interface UseGetNotificationProps {
  id: number;
  enabled?: boolean;
  refetchIntervalMs?: number;
  pageSize?: number;
}

export function useGetUserNotification({
  id,
  enabled = true,
  refetchIntervalMs,
  pageSize = 50,
}: UseGetNotificationProps) {
  return useQuery({
    enabled,
    refetchInterval: refetchIntervalMs,
    queryKey: ['notification', id, pageSize],
    queryFn: async () => {
      return axiosInstance<Notification>(
        getAPIURL(
          `/Notification/${id}/Notifications?pageNumber=1&pageSize=${pageSize}`
        )
      ).then((response) => response.data);
    },
  });
}